// Strips rlv_* and utm_* params from the hash route's query string after a
// click from a Releva email. The click was already recorded server-side by
// /api/v0/click before the redirect; the params on the URL serve no purpose
// here and can confuse route guards / analytics page parsers, so we clean
// them up before React mounts.
//
// Gated on `rlv_at` so we don't strip legitimate UTM-tagged external traffic.
export const stripEmailClickParams = () => {
  const hash = window.location.hash;
  const queryStart = hash.indexOf('?');
  if (queryStart === -1) return;

  const path = hash.slice(0, queryStart);
  const params = new URLSearchParams(hash.slice(queryStart + 1));
  if (!params.has('rlv_at')) return;

  for (const key of [...params.keys()]) {
    if (key.startsWith('rlv_') || key.startsWith('utm_')) {
      params.delete(key);
    }
  }

  const remaining = params.toString();
  const newHash = remaining ? `${path}?${remaining}` : path;
  window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}${newHash}`);
};
